<template>
	<div class="customerAccount">
		<!-- 小程序权限 -->
		<el-row type="flex" justify="space-between" align="middle" class="permission">
			<el-col class="detail" :span="3">
				<span>小程序权限</span>
			</el-col>

			<el-col
				v-for="item in permissionList"
				:key="item.id"
				class="detail"
				:class="{ active: item.bind }"
				:span="3"
			>
				<p>{{ item.label }}</p>
				<i v-if="item.bind" class="el-icon-success"></i>
				<i v-else class="el-icon-error"></i>
			</el-col>

			<el-col class="detail" :span="3">
				<el-button type="primary" v-if="editPermission" @click="isShowDialog">编辑</el-button>
			</el-col>
		</el-row>
		<!-- 修改权限对话框 -->
		<el-dialog title="小程序权限" :visible.sync="isShowPer" width="30%" class="dialog">
			<div class="content">
				<el-switch
					v-for="item in permissionList"
					:key="item.id"
					v-model="item.bind"
					:inactive-text="item.label"
					inactive-color="#C0CCDA"
					active-color="#13ce66"
				></el-switch>
			</div>
			<div class="btn">
				<el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="setCustomerpermissiondetail">确 定</el-button>
			</div>
		</el-dialog>

		<el-row type="flex" class="row-bg" justify="space-between">
			<div class="detail-title">
				<div class="detail-setmeal">{{ customer.businessLineName || '暂无' }}</div>
				<div style="margin: 0">
					<span>{{ customer.custName }}</span>
					<span v-if="customer.primaryIndustryName || customer.secondIndustryName"
						>({{ customer.primaryIndustryName }}-{{ customer.secondIndustryName }})</span
					>
					<span v-if="customer.foreignFirstIndustryName || customer.foreignSecondIndustryName"
						>({{ customer.foreignFirstIndustryName }}-{{
							customer.foreignSecondIndustryName
						}})</span
					>
				</div>
			</div>
			<el-button type="primary" v-if="editPermission" @click="add">新增</el-button>
		</el-row>
		<data-list
			style="margin-top: 10px"
			:data="data"
			:columns="columns"
			:loading="loading"
			:page="page"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>

		<el-dialog
			title="客户账号"
			:visible.sync="dialogVisible"
			width="60%"
			center
			@closed="handleClose"
		>
			<!--<div style="height: 550px;">-->
			<!-- 新增弹窗 -->
			<el-scrollbar class="dialogScroll" v-if="setGroupsType == 'add'">
				<form-combination
					style="padding-right: 20px"
					size="small"
					:form-data="groups"
				></form-combination>
			</el-scrollbar>

			<!--</div>-->
			<!-- 编辑的表单 -->
			<el-form :model="editFormData" label-width="140px" size="medium" v-else>
				<el-form-item label="姓名">
					<el-input v-model="editFormData.name"></el-input>
				</el-form-item>
				<el-form-item label="手机号">
					<!-- <el-input v-model="editFormData.mobile"></el-input> -->
					<skyPhoneAreaCode v-model="editFormData.mobile"></skyPhoneAreaCode>
				</el-form-item>
				<!-- <el-form-item label="个人邮箱">
					<el-input v-model="editFormData.privateMailbox"></el-input>
				</el-form-item> -->
				<el-form-item label="角色">
					<sky-radio
						v-model="editFormData.role"
						:options="roleList"
						:props="{
							label: 'name',
							value: 'id',
						}"
					></sky-radio>
				</el-form-item>
				<el-form-item label="服务权限">
					<sky-select-addEmail
						v-model="editFormData.siteDtoList"
						:options="websiteList"
						:row="row"
					></sky-select-addEmail>
				</el-form-item>
				<el-form-item label="企业邮箱">
					<company-mail
						v-model="getQyEmailList"
						@validEmail="validEmail"
						@openingMail="openingMail"
						@resetEmail="resetEmail"
						@resetPassword="resetPassword"
						@on-data="onEmailData"
					></company-mail>
				</el-form-item>
				<el-form-item label="推送服务评价">
					<sky-radio v-model="editFormData.flagPushEvaluation" :options="evaluateList"></sky-radio>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type="textarea" v-model="editFormData.remark"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" :loading="btnLoading" @click="submit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue';
import messageSwitch from '@/components/customer/messageSwitch';
import columnList from '@/components/tools/columnList';
import listPageCreate from '@/mixins/listPageCreate';
import simpleFormPageCreate from '@/components/iglobalwin/formCombination/formService.js';
import api from '@/backend/apiConfig/apiConfig';
import customer from '@/backend/services/account/customer';
import { roleList } from '@/common/dictionary';
import { getTaskFlowList } from '@/backend/services/task/task';
import { validMobile } from '@/common/elementValid';
import companyMail from '@/components/setting/companyMail.vue';
import skyRadio from '@/components/iglobalwin/formComponents/sky-radio.vue';
import vm from '@/common/confirm.js';
// import dataList from './test.js'
import { mapGetters } from 'vuex';
// import skySelect from '@/components/iglobalwin/formComponents/sky-select.vue';
import servicePermission from '@/backend/pages/customerinfo/component/servicePermission.vue';
import skySelectAddEmail from '@/backend/pages/customerinfo/component/sky-select-addEmail.vue';
import skyPhoneAreaCode from '@/components/iglobalwin/formComponents/sky-phone-areaCode.vue';

// 手机号验证
function validMobileCode() {
	return {
		required: true,
		trigger: 'blur',
		validator: (_rule, val, valid) => {
			let [code, value] = val.split(' ');
			let reg = /^(?:[0-9]●?){6,14}[0-9]$/;

			if (!code) return valid(new Error('请选择区号'));
			if (!value) return valid(new Error('请输入手机号'));
			if (!reg.test(value)) return valid(new Error('请输入正确的手机号'));

			valid();
		},
	};
}

const page = listPageCreate({
	searchConfig: {
		api: api.customer.getCustomerAccountList,
		method: 'POST',
	},
	getQuery(obj, that) {
		return _.assign(obj, { customerBusinessLineId: that.$route.query.serviceLineId });
	},
});
export default {
	name: 'customerAccount',
	components: {
		skySelectAddEmail,
		formCombination,
		companyMail,
		skyRadio,
		skyPhoneAreaCode,
	},
	mixins: [page],
	data() {
		const that = this;
		const columns = [
			{
				label: '姓名',
				bind: 'name',
			},
			{
				label: '手机号',
				bind: 'mobile',
			},
			{
				label: '微信',
				bind: 'wechatName',
			},
			{
				label: 'APP/邮箱绑定情况',
				bind(row) {
					let { emailBindCount } = row;
					if (row.flagLoginApp) {
						return `已绑定/${emailBindCount}`;
					} else {
						return `${row.flagLoginApp == 0 ? '未绑定' : '-'}/${emailBindCount}`;
					}
				},
			},
			{
				label: '默认邮箱',
				bind: 'defaultMailboxList',
				type: servicePermission,
			},
			{
				label: '角色',
				bind: 'roleName',
				showOverflowTooltip: true,
			},
			{
				label: '服务权限',
				bind: 'siteDomainList',
				type: 'custom',
				componentName: columnList,
			},
			{
				label: '询盘通知',
				type: 'custom',
				componentName: messageSwitch,
				activeValue: 1,
				inactiveValue: 0,
				async event(row) {
					await customer.toggleMsgStatus(row.id);
					that.query();
				},
				bind: 'flagMsg',
			},
			{
				label: '备注',
				bind: 'remark',
				type: 'remark',
			},
			{
				label: '操作',
				type: 'btnClick',
				align: 'center',
				width: 200,
				bind(row) {
					let operate = [
						{
							text: '编辑',
							trigger: async function (row) {
								that.row = row;
								let val = await customer.getCustomerAccountDetail(row.id);
								let { mobile, mobileCode } = val.data;
								val.data.mobile = `${mobileCode || '+86'} ${mobile || ''}`;
								that.obj = val.data;
								that.obj.siteDtoList = [];
								val.data.qyEmailList.map(item => {
									that.obj.siteDtoList.push({
										serviceSiteId: item.siteId,
										defaultMailbox: item.defaultMailbox,
									});
								});
								that.setGroupsType = 'redact';
								that.setGroups(val.data);
								that.dialogVisible = true;
								that.emailStatus = 1;
								that.editFormData = _.cloneDeep(that.obj);
								that.emailDataList = [];
							},
							showButton: function (row) {
								let { role } = row;
								if (that.editPermission) {
									if (role === 1) {
										return that.getPermission(
											that.$permissionData.accountManagementEditor.englishName
										);
									}
									return true;
								} else return false;
							},
						},
					];
					if (row.role !== 0) {
						return operate.concat({
							text: '删除',
							trigger(row) {
								that.deleteAccount(row);
							},
							showButton: function (row) {
								let { role } = row;
								if (that.editPermission) {
									if (role === 1) {
										return that.getPermission(
											that.$permissionData.accountManagementEditor.englishName
										);
									}
									return true;
								} else return false;
							},
						});
					}
					return operate;
				},
			},
		];
		return {
			statusValue: '',
			roleList: [],
			row: {},
			options: [
				{
					id: '1574752065530773504',
					username: '2314020855@qq.com',
					personal: 'sdfsdfdsaf',
					status: 2,
					statusName: '已验证',
					sendFailFlag: false,
					defaultFlag: true,
				},
			],
			formData: {
				id: '',
				username: '',
			},
			props: {
				label: 'username',
				value: 'id',
			},
			evaluateList: [
				{
					label: '是',
					value: true,
				},
				{
					label: '否',
					value: false,
				},
			],
			websiteList: [],
			groups: {},
			obj: {},
			dialogVisible: false,
			customer: {},
			btnLoading: false,
			type: 'add',
			columns: columns,
			// 小程序权限
			permission: {},
			permissionList: [],
			dialog: {},
			isShowPer: false,
			oldMailbox: '',
			oldPassword: '',
			setGroupsType: '',
			emailStatus: 1,
			editFormData: {
				name: '',
				mobile: '',
				role: '',
				privateMailbox: '',
				siteIdList: [],
				qyEmailList: [],
				defaultMailbox: [],
				siteDtoList: [],
			},
			emailDataList: [],
		};
	},
	methods: {
		onEmailData(data) {
			this.emailDataList = data;
		},
		async validEmail(col, handleLoading) {
			try {
				if (!col.mailbox || !col.password) return vm._warn('请输入邮箱地址或密码');
				let param = Object.assign(col, {
					id: this.obj.id,
				});
				if (handleLoading) handleLoading();
				let res = await customer.emailvenify(param);
				if (res.status >= 200 && res.status < 400) {
					if (res.data) {
						vm._success('邮箱验证成功');
						col.checkStatus = 2;
					} else {
						vm._warn('邮箱验证失败');
						col.checkStatus = 3;
					}
					if (handleLoading) handleLoading(col);
				}
			} catch (e) {
				vm._warn('邮箱验证失败');
				col.checkStatus = 3;
				if (handleLoading) handleLoading();
			}
		},
		async openingMail(col, handleLoading) {
			if (!col.domainId) return vm._warn('请选择渠道账号');
			if (!col.email) return vm._warn('请输入邮箱名');
			try {
				await vm._confirm(`是否开通【${col.email}@${col.emailDomain}】？`);
			} catch (error) {
				return;
			}
			const self = this;
			let param = {
				domainId: col.domainId,
				email: col.email,
				accountId: self.obj.id,
				serviceSiteId: col.siteId,
			};
			try {
				if (handleLoading) handleLoading();
				let res = await customer.createPersonMail(param);
				if (res.data == 'success') {
					vm._success('开通成功');
					col.emailType = 2;
					col.flagOpen = true;
					if (handleLoading) handleLoading(col);
				}
			} catch (e) {
				vm._warn('开通失败');
				if (handleLoading) handleLoading();
				console.error(e);
			}
		},
		// 重置密码
		async resetPassword(col, handleLoading) {
			if (!col.flagOpen && col.emailType == 2) return vm._warn('请先开通邮箱');
			try {
				await vm._confirm(`是否重置【${col.email}@${col.domain}】的密码？`);
			} catch (e) {
				return;
			}

			const self = this;
			let param = {
				domainId: col.domainId,
				accountId: self.obj.id,
				serviceSiteId: col.siteId,
			};
			try {
				if (handleLoading) handleLoading();
				let res = await customer.resetPassword(param);
				if (res.data == 'success') {
					vm._success('重置成功');
					if (handleLoading) handleLoading();
				}
			} catch (e) {
				vm._warn('重置失败');
				if (handleLoading) handleLoading();
				console.error(e);
			}
		},
		// 重置邮箱
		async resetEmail(col, handleLoading) {
			if (!col.flagOpen && col.emailType == 1) return vm._warn('请先开通邮箱');
			if (!col.mailbox && !col.password) return vm._warn('请先开通邮箱');
			try {
				await vm._confirm(`是否重置【${col.mailbox}】邮箱？`);
			} catch (e) {
				return;
			}

			const self = this;
			let param = {
				id: self.obj.id,
				siteId: col.siteId,
			};
			try {
				if (handleLoading) handleLoading();
				let res = await customer.resetEmail(param);
				if (res.status >= 200 && res.status < 400) {
					vm._success('邮箱重置成功');
					col.mailbox = null;
					col.password = null;
					if (handleLoading) handleLoading(col);
				}
			} catch (e) {
				vm._warn('邮箱重置失败');
				if (handleLoading) handleLoading();
				console.error(e);
			}
		},
		deleteAccount({ id, name }) {
			this.$confirm(`确定删除${name}的账号？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'danger',
			}).then(() => {
				customer.deleteCustomerAccount(id).then(() => {
					this.$message.success('删除成功');
					this.query();
				});
			});
		},
		add() {
			this.setGroupsType = 'add';
			this.setGroups();
			this.dialogVisible = true;
			this.emailStatus = 1;
		},
		done() {},
		getWebsiteList(id) {
			customer.domainname(id).then(val => {
				val.data.forEach(e => {
					e.label = e.serviceCode ? e.name + '(' + e.serviceCode + ')' : e.name;
				});
				this.websiteList = val.data;
			});
		},
		getTaskFlowList(type) {
			return () => {
				return getTaskFlowList({
					type,
				});
			};
		},
		async submit() {
			const that = this;
			this.btnLoading = true;
			const reset = () => {
				that.btnLoading = false;
				that.dialogVisible = false;
				that.emailStatus = false;
				that.query();
			};

			let groups = _.cloneDeep(this.groups);
			let editFormData = _.cloneDeep(this.editFormData);

			let [code, value] = groups.mobile.value.split(' ');

			groups.mobileCode = {
				value: code,
			};

			groups.mobile = {
				value: value,
			};

			groups.serviceIdList = {
				value: groups.siteDtoList.value.map(item => item.serviceSiteId),
			};

			let [_code, _value] = editFormData.mobile.split(' ');
			editFormData.serviceIdList = editFormData.siteDtoList.map(item => item.serviceSiteId);
			editFormData.mobileCode = _code;
			editFormData.mobile = _value;

			delete editFormData.siteDtoList;
			delete groups.siteDtoList;

			// 新增
			if (this.setGroupsType == 'add') {
				try {
					let result = await simpleFormPageCreate(
						{
							api: api.customer.addCustomerAccount,
							type: 'Post',
							data: groups,
						},
						res => {
							let obj = Object.assign({}, res);
							obj.customerBusinessLineId = this.$route.query.serviceLineId;
							this.obj.id && (obj.id = this.obj.id);
							return obj;
						}
					).submit();
					if (result.status >= 200 && result.status < 400) {
						reset();
					}
				} catch (e) {
					this.btnLoading = false;
					console.error(e);
				}
			}
			// // 编辑
			if (this.setGroupsType === 'redact') {
				// 有无内容
				let status;
				if (this.emailDataList.length > 0) {
					status = [];
					/**
					 * 改变    已验    [true]
					 * 改变    未验    [false]
					 * 未改变  有值
					 * 未改变  无值    false
					 */
					let ed = this.emailDataList;
					for (let i in ed) {
						// emailType 1 手动  checkStatus 2 验证成功 handChanged 是否改了
						if (ed[i].emailType == 1) {
							if (ed[i].handChanged) {
								//更改了邮箱 保存验证状态
								status.push(ed[i].checkStatus == 2);
							} else {
								//没有更改 判断是否有值
								if (!ed[i].mailbox || !ed[i].password) {
									// status = false     //2019/12/6日注释 David
									// break
								}
							}
						}
					}
					if (typeof status == 'boolean' && !status) {
						this.btnLoading = false;
						return vm._warn('请先验证邮箱');
					}
					if (status.length > 0 && !status.every(item => item)) {
						this.btnLoading = false;
						return vm._warn('请确保邮箱验证成功');
					}
				}
				try {
					let res = await customer.editCustomerAccount(editFormData, {
						id: editFormData.id,
					});
					if (res.status >= 200 && res.status < 400) {
						reset();
					}
				} catch (e) {
					this.btnLoading = false;
					console.error(e);
				}
			}
		},
		handleClose() {
			this.obj = {};
			this.type = 'add';
		},
		isShow(formData, id) {
			return formData.correlation.value.some(item => item === id);
		},
		setGroups(obj = {}) {
			const that = this;
			let { roleList } = this;
			that.groups = {
				name: {
					label: '姓名',
					formType: 'sky-input',
					value: obj.name,
				},
				mobile: {
					label: '手机号',
					formType: 'sky-phone-areaCode',
					value: `${obj.mobileCode || '+86'} ${obj.mobile || ''}`,
					rules: [validMobileCode()],
				},
				role: {
					label: '角色',
					formType: obj.role == 1 ? 'sky-span' : 'sky-radio',
					data: obj.role !== 1 ? obj.role : obj.roleName,
					value: obj.role,
					options: roleList,
					props: {
						label: 'name',
						value: 'id',
					},
				},
				siteDtoList: {
					label: '服务权限',
					formType: skySelectAddEmail,
					options: that.websiteList,
					value: obj.siteIdList || [],
				},
				flagPushEvaluation: {
					label: '推送服务评价',
					formType: 'sky-radio',
					options: that.evaluateList,
					value: obj.flagPushEvaluation,
				},
				remark: {
					label: '备注',
					formType: 'sky-textarea',
					type: 'textarea',
					value: obj.remark,
				},
			};
		},
		async getCustomerDetail(id) {
			let data = await customer.getCustomerDetail({
				customerId: id,
			});
			this.getCustomerpermissiondetail(data.data.customerBusinessLineId);
			this.customer = data.data;
		},
		// 显示对话框
		isShowDialog() {
			this.dialog = { ...this.permission };
			this.isShowPer = true;
		},
		// 请求小程序权限状态
		async getCustomerpermissiondetail(id) {
			let value = await customer.getCustomerpermissiondetail(id);
			this.permission = { ...value.data };
			this.dialog = { ...value.data };
			this.traverse();
		},
		// 改变数据结构
		traverse() {
			this.permissionList = [
				{
					id: 1,
					label: '询盘',
					bind: this.permission.isEnquiry,
				},
				{
					id: 2,
					label: '网站统计',
					bind: this.permission.isWebsiteStatistics,
				},
				{
					id: 3,
					label: '社媒',
					bind: this.permission.isSocialMedia,
				},

				{
					id: 4,
					label: '效果报告',
					bind: this.permission.isReport,
				},
				{
					id: 5,
					label: '服务进度',
					bind: this.permission.isServiceSchedule,
				},
			];
		},
		cancel() {
			this.traverse();
			this.isShowPer = false;
		},
		getDialogValue() {
			this.permissionList.forEach(item => {
				if (item.id == 1) {
					this.permission.isEnquiry = item.bind;
				} else if (item.id == 2) {
					this.permission.isWebsiteStatistics = item.bind;
				} else if (item.id == 3) {
					this.permission.isSocialMedia = item.bind;
				} else if (item.id == 4) {
					this.permission.isReport = item.bind;
				} else if (item.id == 5) {
					this.permission.isServiceSchedule = item.bind;
				}
			});
		},
		// 设置小程序权限状态
		async setCustomerpermissiondetail() {
			let id = this.permission.id;
			this.getDialogValue();
			let data = this.permission;
			this.isShowPer = false;
			let res = await customer.setCustomerpermissiondetail(id, data);
			// 请求状态判断
			if (res.status == '204') {
				this.$message({
					message: '设置成功',
					type: 'success',
				});
				this.getCustomerpermissiondetail(id);
			}
		},
		// 默认角色列表
		async getDefaultRoleList() {
			let id = this.customer.id;
			try {
				let { data } = await customer.defaultRoleList({
					customerId: id,
					displayLength: 100,
					displayStart: 1,
				});
				let list = data.data.filter(item => {
					item.disabled = true;
					return item.tag === 1;
				});
				this.roleList = roleList.concat(list);
			} catch (error) {
				this.roleList = roleList;
				this.$message.warning('默认角色数据错误');
			}
		},
	},
	watch: {
		'editFormData.siteDtoList': {
			handler(siteDtoList) {
				/**
				 * 监听多选框，把返回的企业数据id取出来，
				 * 遍历多选框，如果返回数据中不包含的话，添加进去
				 */
				if (this.emailDataList.length > 0)
					this.editFormData.qyEmailList = _.cloneDeep(this.emailDataList);
				let mailbox = _.cloneDeep(this.editFormData.qyEmailList).map(item => item.siteId);
				siteDtoList.map(({ serviceSiteId: id }) => {
					let qyEmail = this.websiteList.find(site => site.id == id);
					if (!mailbox.includes(id)) {
						this.editFormData.qyEmailList.push({
							emailDomain: qyEmail.emailDomain,
							emailType: qyEmail.qyEmailType == 1 ? 2 : 1,
							flagOpen: null,
							mailbox: null,
							password: null,
							siteId: qyEmail.id,
							//
							checkLoading: false,
							handChanged: false,
							openingLoading: false,
							resetLoading: false,
							checkStatus: 1,
							email: null,
						});
					}
				});
				/*删除
        遍历返回的数据  如果多选框中不包含的话  删除数据
        */
				mailbox.map(id => {
					if (!siteDtoList.find(({ serviceSiteId }) => serviceSiteId === id)) {
						let idx = this.editFormData.qyEmailList.findIndex(item => item.siteId == id);
						this.editFormData.qyEmailList.splice(idx, 1);
					}
				});
			},
			deep: true,
		},
	},
	computed: {
		...mapGetters(['customerId']),
		new: key => {
			if (key == 'isEnquiry') {
				return '询盘';
			}
		},
		getQyEmailList: {
			// emailType	邮箱类型(1.手动；2.自动)
			get() {
				if (this.editFormData.qyEmailList.length > 0) {
					this.editFormData.qyEmailList.forEach(item => {
						if (!item.emailType) {
							let qyEmailType = this.websiteList.find(site => site.id == item.siteId).qyEmailType;
							item.emailType = qyEmailType == 1 ? 2 : 1;
						} else {
							if (item.emailType == 3) item.emailType = 1;
						}
					});
				}
				return this.editFormData.qyEmailList;
			},
			set() {},
		},
		editPermission(self) {
			return self.getPermission(self.$permissionData.accountManageEditorPermissions.englishName);
		},
	},
	async mounted() {
		await this.getCustomerDetail(this.$route.query.id);
		this.getWebsiteList(this.$route.query.serviceLineId);
		this.getDefaultRoleList();
		this.query();
	},
};
</script>

<style scoped lange="scss">
.detail-title {
	font-size: 18px;
	font-weight: bold;
	display: flex;
	justify-content: flex-start;
	align-items: center;
}

.detail-setmeal {
	width: 72px;
	height: 34px;
	text-align: center;
	line-height: 34px;
	color: #fff;
	font-size: 16px;
	font-weight: normal;
	background-color: #ffce3d;
	border-radius: 4px;
	margin-right: 16px;
}

.permission {
	height: 60px;
	background-color: #fff;
	margin: 10px 0 30px !important;
	padding: 10px;
	box-sizing: border-box;
}

.permission .detail {
	height: 100%;

	/* border: 1px solid red; */
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 14px;
	color: #606266;
}

.permission .detail span {
	font-size: 14px;
	color: #4a4a4a;
	font-weight: 700;
}

.permission .detail i {
	font-size: 12px;
	margin-left: 4px;
	color: #f56c6c;
}

.permission .detail.active i {
	color: #67c23a;
}

.dialog .content {
	width: 100%;

	/* height: 60px; */
	display: flex;
	flex-direction: column;
	align-items: center;
}

.dialog .content .el-switch {
	width: 60%;
	margin: 10px 0;
	display: flex;
	justify-content: space-between;
}

.dialog .btn {
	width: 100%;
	height: 40px;
	display: flex;
	justify-content: flex-end;
	margin: 40px 0 0;
}

.dialog .btn .el-button {
	margin: 0 10px;
}
</style>
